import axios from '../axios'

/**
 * 解绑 驾校
 * @param {*} data [{managerDeptId: '212121212'}]
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059422  20220424 
 */
export const unBindSchoolMulti = data => {
    return axios({
        url: '/sysmanagerdept/unBind',
        method: 'post',
        data
    })
}
/**
 * 绑定 驾校
 * @param {*} data 
 * deptId	是	string	机构Id
    schoolIds	是	List<String>	授权驾校ids
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059420 20220424 
 */
export const bindSchoolMulti = data => {
    return axios({
        url: '/sysmanagerdept/bind',
        method: 'post',
        data
    })
}
////////////////////////////////////////////////
/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/dept/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/dept/delete',
        method: 'post',
        data
    })
}
// 查询机构树
export const findDeptTree = (params) => {
    return axios({
        url: '/dept/listTree',
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/dept.js